import { cn } from '@/lib/cn';

interface PinkDotProps {
  /** Tailwind size class pair, e.g. "h-1.5 w-1.5". */
  size?: string;
  /** Add a soft pink glow halo. */
  pulse?: boolean;
  className?: string;
}

/**
 * The pink fullstop / signal dot. Used as the brand mark's punctuation,
 * as a list bullet, and as a status indicator.
 * Never green. Never any colour but pink.
 */
export const PinkDot = ({ size = 'h-1.5 w-1.5', pulse = false, className }: PinkDotProps) => (
  <span
    aria-hidden
    className={cn(
      'inline-block rounded-full bg-pink',
      pulse && 'animate-[pulse_2.4s_var(--hottr-ease)_infinite] shadow-signal',
      size,
      className,
    )}
  />
);
